import { HTMLAttributes } from "react";
import cn from "classnames";

/**
 * Italic Instrument Serif run inside a DM Sans heading, as in the marketing
 * hero: "Reports in <SerifAccent>a fraction of the time.</SerifAccent>"
 */
export default function SerifAccent({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        "font-serif-accent italic font-normal text-base-content/70",
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
